(() => {
  'use strict';

  if (customElements.get('facet-filters-form')) return;

  class FacetFiltersForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-facets-form]');
      this.status = this.querySelector('[data-facets-status]');
      this.submitTimer = null;
      this.mobileFilters = this.querySelector('.facets__mobile-disclosure');
      this.desktopFilters = this.querySelector('.facets__desktop-groups');
      this.mobileQuery = window.matchMedia('(max-width: 989px)');

      if (!this.form) return;
      [this.mobileFilters, this.desktopFilters].forEach((container) => {
        container?.querySelectorAll('input, select').forEach((control) => {
          if (control.disabled) control.dataset.filterDisabled = 'true';
        });
      });
      this.syncResponsiveControls();
      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.syncResponsiveControls.bind(this));
      } else {
        this.mobileQuery.addListener(this.syncResponsiveControls.bind(this));
      }
      this.form.addEventListener('change', this.onChange.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    syncResponsiveControls() {
      const mobileActive = this.mobileQuery.matches;
      this.mobileFilters?.querySelectorAll('input, select').forEach((control) => {
        control.disabled = !mobileActive || control.hasAttribute('data-filter-disabled');
      });
      this.desktopFilters?.querySelectorAll('input, select').forEach((control) => {
        control.disabled = mobileActive || control.hasAttribute('data-filter-disabled');
      });
    }

    onChange(event) {
      const target = event.target;
      if (!target.matches('input, select')) return;

      window.clearTimeout(this.submitTimer);
      const delay = target.type === 'number' ? 700 : 150;
      this.submitTimer = window.setTimeout(() => this.form.requestSubmit(), delay);
    }

    onSubmit() {
      const results = document.getElementById(this.dataset.resultsId || 'ProductGridContainer');
      results?.setAttribute('aria-busy', 'true');
      this.setAttribute('aria-busy', 'true');
      if (this.status) this.status.textContent = 'Updating products';
      this.form.querySelectorAll('button[type="submit"]').forEach((button) => {
        button.disabled = true;
      });
    }
  }

  customElements.define('facet-filters-form', FacetFiltersForm);
})();
